import {Injectable} from '@angular/core';
import {AppNameEnum, FrontendDocument, NachdigalService} from '@nachdigal';
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DocumentsMetadataService {

    constructor(private readonly documentService: NachdigalService) {
    }

    public getDocuments(): Promise<Array<FrontendDocument>> {
        const euN = this.documentService.getDocumentsMetadata(AppNameEnum.FragebogenEUn);
        const kapG = this.documentService.getDocumentsMetadata(AppNameEnum.FragebogenKapG);
        const persG = this.documentService.getDocumentsMetadata(AppNameEnum.FragebogenPersG);
        const betPG = this.documentService.getDocumentsMetadata(AppNameEnum.FragebogenBetPG);
        const kapGAus = this.documentService.getDocumentsMetadata(AppNameEnum.FragebogenKapGAus);

        return combineLatest([euN, kapG, persG, betPG, kapGAus]).pipe(
            map(([euNMap, kapGMap, persGMap, betPGMap, kapGAusMap]) =>
                euNMap.concat(kapGMap.concat(persGMap.concat(betPGMap.concat(kapGAusMap)))))
        ).toPromise();
    }
}
